import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/tmh-unplugged", label: "Unplugged" },
  { to: "/courses", label: "Courses" },
  { to: "/play-first-pay-later", label: "Trial Sessions" },
  { to: "/founder", label: "Founder" },
  { to: "/testimonials", label: "Stories" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-paper/85 border-b border-ink/5" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-logo" aria-label="The Music Highway home">
          <Logo />
        </Link>
        <nav className="hidden md:flex items-center gap-5" data-testid="nav-links">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${isActive ? "text-brand" : "text-ink/70 hover:text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          <Link
            to="/play-first-pay-later"
            data-testid="nav-cta-fitness-check"
            className="hidden sm:inline-flex items-center rounded-full bg-brand text-white text-sm font-semibold px-5 py-2.5 hover:bg-ink transition-colors duration-300"
          >
            Book Trial Sessions
          </Link>
          <button
            className="md:hidden w-9 h-9 flex items-center justify-center text-ink"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-ink/5 bg-paper px-5 py-4 flex flex-col gap-1" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `py-2.5 text-base font-medium ${isActive ? "text-brand" : "text-ink/75"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/play-first-pay-later"
            data-testid="mobile-nav-cta-fitness-check"
            className="mt-2 inline-flex justify-center rounded-full bg-brand text-white text-sm font-semibold px-5 py-3"
          >
            Book Trial Sessions
          </Link>
        </nav>
      )}
    </header>
  );
}
